import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconProofreading = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72.00397939999999,
			d: "M332.59 570.344 459.857 697.62 691.404 466.07"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72,
			d: "M826.73 254.47v607.01c0 35.73-29.01 64.74-64.74 64.74H262.01c-35.73 0-64.74-29.01-64.74-64.74V254.47c0-35.73 29.01-64.74 64.74-64.74h499.98c35.73 0 64.74 29.01 64.74 64.74M434.71 151.78c0-39.79 32.3-72.09 72.09-72.09 39.78 0 72.08 32.3 72.08 72.09"
		})
	]
});
export default SvgIconProofreading;
